import { getModule } from 'vuex-module-decorators';
import ProfileStore from '@/profile/store';
import { store } from '@/store';

const profileStore = getModule(ProfileStore, store);

export const profileAccountsResolver = async (): Promise<void> => {
	await profileStore.getAndSetAllAccounts();
	profileStore.setInstitutionsFromAccounts();
	profileStore.setDefaultSelectedInstitution();
};
